import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/audit/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function auditDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/audit`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 撤销
export function rollbackDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/rollback`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function downloadTable(data) {
  return request.send({
    url: `/joker/order/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
export function setTimeout(data) {
  return request.send({
    url: `/joker/order/config/bargaining`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function getTimeout() {
  return request.send({
    url: `/joker/order/config/bargaining`,
    method: "get",
  });
}
